import { Component, OnInit, Inject, Optional } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppState } from '../../../../../../store/reducers';
import { Store } from '@ngrx/store';
import { AlertService } from '../../../../../../commons/services/alert.service';
import { Closures } from '../../../../../../commons/models/closures';
import * as ClosuresActions from '../../../../../../store/actions/closures.actions';
import { Tenants } from '../../../../../../commons/models/tenants';


@Component({
    selector: 'app-new-closures',
    templateUrl: './new-closures.component.html',
    styleUrls: ['./new-closures.component.scss']
})
export class NewClosuresComponent {
    private unsubscribe$ = new Subject<void>();
    closuresForm: UntypedFormGroup;
    closures: Closures;

    constructor(
        private store$: Store<AppState>,
        private alertService: AlertService,
        private fb: UntypedFormBuilder,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {

        if (this.data) {
            this.closures = this.data.closure;
        } 
     
        this._createForm();

        // console.log("Dati passati al componente:", this.data);

        this.ngOnChanges();
        
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    private _createForm() {
        let closuresGroup = {
            closure_date: ["", Validators.required],
            //tenant_id: [this.data?.tenant_id, Validators.required]
        };
    
        this.closuresForm = this.fb.group(closuresGroup);
        // console.log('Form creato con i valori:', this.closuresForm.value);
    
    }
   

    private ngOnChanges() {
        if (this.closuresForm) {
          this.closuresForm.reset();
          
          this._initFormValues(this.closures);
        }
    }

    private _initFormValues(closures?: Closures) {
        if (closures) {
           
            const closureDate = closures.closureDate ? new Date(closures.closureDate) : null;
            const tenantId = this.data?.tenant_id ?? null;
            
            // Verifica che closureDate sia valido
            if (isNaN(closureDate.getTime())) {
                console.error('Invalid closureDate:', closures.closureDate);
            }
    
            this.closuresForm.patchValue({
                closure_date: closureDate ? closures.closureDate : null,
                tenant_id: tenantId
            });

        } 
        else {
            this.closuresForm.markAllAsTouched();
        }
    }
    


    private _prepareSaveClosure(): Closures {
        let closureDate = Closures.fromFormGroup(this.closuresForm, this.closures);
        closureDate.tenantId = this.data?.tenant_id;

        return closureDate

    }

    save() {
        let unsavedEntity = this._prepareSaveClosure();
        // Per debug
        // if (!unsavedEntity.tenantId) {
        //     console.error("Errore: tenant_id mancante", unsavedEntity);
        //     return;
        // }
        this.store$.dispatch(ClosuresActions.saveClosure({ closures: unsavedEntity }));
    }
    

    close() {
        if (this.closuresForm.dirty) {
            // Se ci sono modifiche, mostra il dialog di conferma
            this.store$.dispatch(ClosuresActions.requestCloseClosuresDialog());
        } else {
            // Se il form è pristine (nessuna modifica), chiudi
            this.store$.dispatch(ClosuresActions.closeClosuresDialog());
        }
    }

    deleteClosure() {
        if (this.closures) {
            this.store$.dispatch(ClosuresActions.deleteClosure({ closure: this.closures.toDTO() }));
        }
    }

    revert() {
    this.ngOnChanges();
    }

    get _closures(): Closures {
    return this.closures;
    }

    set closure(closures: Closures) {
    this.closures = closures;
    this.ngOnChanges();
    }



}